import type { Shift } from '@shared/types/shifts';
import { api } from '../../api';

export interface CreateListingPayload {
  floorPlanId: string;
  highlightedFloorPlanTableIds: string[];
  iconName: string;
  ignoreWarnings?: boolean;
  maximumGuests: number;
  minimumGuests: number;
  name: string;
  price: number;
  publicName: string;
  turnTime: number;
  shiftIds: string[];
}

export interface EditListingPayload {
  floorPlanId: string;
  highlightedFloorPlanTableIds: string[];
  iconName: string;
  ignoreWarnings: boolean;
  maximumGuests: number;
  minimumGuests: number;
  name: string;
  price: number;
  publicName: string;
  turnTime: number;
  shiftIds: string[];
}

export interface ListingWarnings {
  warnings: string[];
}

export interface NewListing {
  createdListingId: string;
}

export interface ListingWithShifts {
  floorPlanId: string;
  highlightedFloorPlanTableIds: string[];
  iconName: string;
  id: string;
  maximumGuests: number;
  minimumGuests: number;
  name: string;
  price: number;
  publicName: string;
  restaurantId: string;
  status: 'active' | 'draft';
  turnTime: number;
  shifts: Shift[];
}

interface ListingHasConflicts {
  hasConflicts: boolean;
}

export const createListing = (
  restaurantId: string,
  listing: CreateListingPayload,
): Promise<ListingWarnings | NewListing> =>
  api.post(`/restaurants/${restaurantId}/listings`, listing);

export const deleteListing = (
  restaurantId: string,
  listingId: string,
): Promise<void> =>
  api.delete(`/restaurants/${restaurantId}/listings/${listingId}`);

export const editListing = (
  restaurantId: string,
  listingId: string,
  listing: EditListingPayload,
): Promise<ListingWarnings> =>
  api.put(`/restaurants/${restaurantId}/listings/${listingId}`, listing);

export const getListing = async (
  listingId: string,
  restaurantId: string,
  signal?: AbortSignal,
): Promise<ListingWithShifts> =>
  api.get<ListingWithShifts>(
    `/restaurants/${restaurantId}/listings/${listingId}`,
    { signal },
  );

export const getListings = async (
  restaurantId: string,
  signal?: AbortSignal,
): Promise<ListingWithShifts[]> =>
  api.get<ListingWithShifts[]>(`/restaurants/${restaurantId}/listings`, {
    signal,
  });

export const checkListingHasConflicts = (
  restaurantId: string,
  listingId: string,
  signal?: AbortSignal,
): Promise<ListingHasConflicts> =>
  api.get(`/restaurants/${restaurantId}/listings/${listingId}/has-conflicts`, {
    signal,
  });
